import React, { FC } from 'react';

import flowRight from 'lodash/flowRight';

import { RouteItemType } from '~/core/router';
import {
  withCheckoutOpeningLayout,
  withHomeScreenRetentionLayout,
  withLiveNotificationLayout,
  withMainLayout,
  withOnboardingLayout,
  withPromoModalLayout,
  withSubModalsLayout,
} from '~/decorators/withLayout';
import lazyComponentLoader from '~/helpers/lazyComponentLoader';
import { useGrowthbookFeatureValue } from '~/hooks/useGrowthbookFeatureValue';
import {
  GB_FEATURE_KEYS,
  GB_FEATURES,
  LiveUserNotificationPlaces,
} from '~/services/abTests/features';

import { getHomePageTitle, HomePagePath } from './constants';

const LegacyHomePage = lazyComponentLoader(() => import('./views/HomePage'));
const HomePageV2 = lazyComponentLoader(
  () => import('./views/HomePageV2/HomePageV2'),
);
const LegacyHomePageWithMainLayout = withMainLayout(LegacyHomePage);
const HomePageV2WithMainLayout = withMainLayout(HomePageV2);

export const HOME_PAGE_REDESIGN_VARIANTS =
  GB_FEATURES[GB_FEATURE_KEYS.JUSTDONE_HOME_PAGE_REDESIGN].variants;

export const HomePageExperiment: FC = () => {
  const variant = useGrowthbookFeatureValue(
    GB_FEATURE_KEYS.JUSTDONE_HOME_PAGE_REDESIGN,
  );

  return variant === HOME_PAGE_REDESIGN_VARIANTS.test ? (
    <HomePageV2WithMainLayout />
  ) : (
    <LegacyHomePageWithMainLayout />
  );
};

export const HomePageRoute: RouteItemType = {
  Component: flowRight(
    withCheckoutOpeningLayout,
    withPromoModalLayout,
    withSubModalsLayout,
    withOnboardingLayout,
    withLiveNotificationLayout(LiveUserNotificationPlaces.HOME),
    withHomeScreenRetentionLayout,
  )(HomePageExperiment),
  path: HomePagePath,
  getTitle: getHomePageTitle,
};
